
export type Document = {
  files: File[];
  itemCount: number;
  pageCount: number;
  category: { name: string; description: string };
};

export type File = {
  name: string;
  size: number;
  id: string;
  extension: string;
  thumbnail: string;
};

export type Criteria = {
  keyword: string;
  category: string;
  page: number;
  sku: string;
  display: "group" | "list";
  sortMethod: number;
};

export type MenuItem={
  parentId: number;
  id:number;
  menuOrder:number;
  displayName:string;
  displayType:string;
  documentPath: string;

};

export type DocumentMenuBranch={
  id:number;
  displayName:string;
  menuOrder:number|null;
  itemLink :string; 
  items:MenuItem[];
}

export enum DocumentSortMethod{
  MostRecent ="Most Recent",
  Oldest = "Oldest",
  AToZ = "A To Z",
  ZToA = "Z To A"
}

